import React, { useState } from 'react';
import './BetSlip.css';

function BetSlip({ user, onBetPlaced }) {
  const [bets, setBets] = useState([]);
  const [stake, setStake] = useState(100);

  const addBet = (bet) => {
    setBets([...bets, { ...bet, id: Date.now() }]);
  };

  const removeBet = (id) => {
    setBets(bets.filter(b => b.id !== id));
  };

  const placeBet = async () => {
    const betData = {
      userId: user.sub,
      bets: bets,
      stake: stake,
      totalOdds: calculateTotalOdds(),
      potentialWin: calculatePayout(),
      status: 'pending',
      createdAt: Date.now()
    };

    try {
      const token = localStorage.getItem('idToken');
      const response = await fetch('https://fj7f90d436.execute-api.us-east-1.amazonaws.com/bets', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(betData)
      });

      if (response.ok) {
        alert('Bet placed successfully!');
        setBets([]);
        setStake(100);
        if (onBetPlaced) onBetPlaced();
      }
    } catch (error) {
      alert('Failed to place bet: ' + error.message);
    }
  };

  const calculateTotalOdds = () => {
    return bets.reduce((acc, bet) => acc * (bet.odds / 100 + 1), 1);
  };

  const calculatePayout = () => {
    return (stake * calculateTotalOdds()).toFixed(2);
  };

  return (
    <div className="bet-slip">
      <h3>Bet Slip</h3>
      {bets.length === 0 ? (
        <p className="empty">No bets added</p>
      ) : (
        <>
          <div className="bets-list">
            {bets.map(bet => (
              <div key={bet.id} className="bet-item">
                <div className="bet-info">
                  <strong>{bet.team}</strong>
                  <span>{bet.type}: {bet.line}</span>
                  <span className="odds">{bet.odds > 0 ? '+' : ''}{bet.odds}</span>
                </div>
                <button onClick={() => removeBet(bet.id)}>×</button>
              </div>
            ))}
          </div>
          <div className="bet-summary">
            <div className="stake-input">
              <label>Stake:</label>
              <input
                type="number"
                value={stake}
                onChange={(e) => setStake(Number(e.target.value))}
                min="1"
              />
            </div>
            <div className="payout">
              <span>Potential Win:</span>
              <strong>${calculatePayout()}</strong>
            </div>
            <button className="place-bet-btn" onClick={placeBet}>
              Place Bet
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default BetSlip;
